const messages = {
  title: "Inbox",
  desc: "Belangrijke berichten, marketingacties en nieuws vindt u hier in uw persoonlijke mailbox.",
  newMessages: "Nieuwe berichten in je inbox",
  link: "Inbox openen",
  showMessages: "Inbox openen",
  message: {
    sender: "Afzender",
    thread: "Onderwerp",
    date: "Datum",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Terug naar het overzicht",
  time: {
    secondsAgo: "{time} seconden geleden",
    minutesAgo: "{time} minuten geleden",
    hoursAgo: "{time} uur geleden",
    daysAgo: "{time} dagen geleden",
  },
};

export default {
  messages,
};
